import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa"; // Icon for success checkmark
import "./ConformationPage.css"; // CSS file for custom styles
import { Link } from "react-router-dom";
import { useAuth } from "../../Pages/AuthContext";
const ConfirmationPage = () => {
  const location = useLocation();
  const { uniqueId } = location.state || {};
  const { isLoggedIn, userData } = useAuth();
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowAnimation(true); // Trigger animation after a short delay
    }, 500);
  }, []);

  return (
    <div className="confirmation-section">
      <div className={`confirmation-box ${showAnimation ? "animate" : ""}`}>
        <div className="icon-container">
          <FaCheckCircle className="success-icon" />
        </div>
        <h2 className="confirmation-title">Registration Complete!</h2>
        <p className="unique-id">
          Your unique ID is: <strong>{uniqueId}</strong>
        </p>
        <p className="thank-you">Thank you for registering!</p>
        <div className="links">
          <Link to={"/"}> HOME</Link>
          <Link
            to="/profile"
            state={{ username: userData?.username }}
          
          >
            PROFILE
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
